import script from "./CheckboxItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckboxItem.vue?vue&type=script&setup=true&lang=ts"

import "./CheckboxItem.vue?vue&type=style&index=0&id=23997c9b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23997c9b"]])

export default __exports__